import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import BlogCard from "./BlogCard";
import { useSiteContent } from "../content/SiteContentContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LatestBlogs() {
  const [posts, setPosts] = useState([]);
  const { content } = useSiteContent();

  useEffect(() => {
    fetch(`${API}/blogs`)
      .then((response) => response.ok ? response.json() : [])
      .then((data) => setPosts(data.slice(0, 3)))
      .catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;
  return (
    <section className="latest-blogs-section" data-testid="latest-blogs-section">
      <div className="page-width">
        <div className="section-heading">
          <div><span className="eyebrow">{content.blog_eyebrow}</span><h2>{content.blog_heading}</h2></div>
          <Link to="/blog" className="blog-all-link" data-testid="view-all-blogs-link">{content.blog_button_label} <ArrowRight size={17} /></Link>
        </div>
        <div className="latest-blogs-grid" data-testid="latest-blogs-grid">
          <BlogCard post={posts[0]} featured />
          <div className="latest-blog-side">
            {posts.slice(1).map((post) => <BlogCard post={post} key={post.id} />)}
          </div>
        </div>
      </div>
    </section>
  );
}